
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorInterfaz } from '@view/a-pedido-cargar/controlador';
    import { Articulo } from '@/__env/lib/Articulos';
    import atributos from './articulos-detalles-atributos.vue';
    import observaciones from './articulos-detalles-observaciones.vue';
    import ofertas from './articulos-detalles-ofertas.vue';
    import jQuery from 'jquery';
    import { Utiles } from '@/__env/pluggins/event-bus';
    @Component( {
        name: "Componente",
        props: {},
        components: {
            observaciones,
            atributos,
            ofertas,

        }
    } )
    export default class Componente extends Vue
    {

        @Prop() public Controlador: ControladorInterfaz;
        public get Articulo() { return this.Controlador.ArticuloSeleccionado; }
        @Watch( 'Articulo', { immediate: true } )
        async onArticulo()
        {
            if ( this.Articulo )
            {
                await this.Articulo.CargarImagenes();
                if ( this.Tab == -1 )
                    this.Tab = this.Controlador.Configuracion.Opciones.PanelDetalleArticulos.PantallaPredeterminada;
            }
        }
        public Tab: number = -1;
        public CarruselItem: number = 0;

        public Tabs: string[] = [
            'Ofertas',
            'Observaciones',
            'Atributos',
        ];

        public get Imagenes()
        {
            if ( this.Articulo.Imagenes )
                return this.Articulo.Imagenes.map( x => x.Archivo500 );
            if ( this.Articulo.Imagen )
                return [this.Articulo.Imagen];
            else
                return [''];
        }

        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );
            jQuery( 'col[width="3"]' ).css( 'width', 'calc( 100vw - 50px - 125px - 100px - 160px - 280px)' );
            jQuery( '#tabla-items' ).css( 'padding-right', '0' ).css( 'width', '100vw' );
            jQuery( '#tabla-items .jexcel_container' ).css( 'width', '100vw' );
            jQuery( '#tabla-items .jexcel_content' ).css( 'width', '100vw' );
            jQuery( '#tabla-items table.jexcel' ).css( 'width', '100vw' );
        }

        mounted()
        {
            this.Eventos.push( Utiles.onKeyUp.subscribe( e => this.onKeyUp( e ) ) );
            if ( !this.$vuetify.breakpoint.smAndDown )
            {
                jQuery( 'col[width="3"]' ).css( 'width', 'calc( 100vw - 50px - 125px - 100px - 160px - 280px - 300px)' );
                jQuery( '#tabla-items' ).css( 'padding-right', '0' ).css( 'width', 'calc( 100vw - 300px)' );
                jQuery( '#tabla-items .jexcel_container' ).css( 'width', 'calc( 100vw - 300px)' );
                jQuery( '#tabla-items .jexcel_content' ).css( 'width', 'calc( 100vw - 300px)' );
                jQuery( '#tabla-items table.jexcel' ).css( 'width', 'calc( 100vw - 300px)' );
            }
        }


        onKeyUp( e: KeyboardEvent )
        {
            if ( e.key == 'ArrowLeft' && e.ctrlKey )
            {
                this.Anterior();
            }
            else if ( e.key == 'ArrowRight' && e.ctrlKey )
            {
                this.Siguiente();
            }
        }


        public esMaximo()
        {
            return this.Tab == this.Tabs.length - 1;

        }
        public esMinimo()
        {
            return this.Tab == 0;
        }

        Siguiente()
        {
            if ( !this.esMaximo() )
                this.Tab++;
        }

        Anterior()
        {
            if ( !this.esMinimo() )
                this.Tab--;
        }

        Ampliar()
        {

            if ( this.Articulo.Imagenes.hasRows() )
                Utiles.Mensajes.Imagenes( this.Articulo.Id, this.Articulo.Imagenes.map( x => x.Archivo1000) )
            else if ( this.Articulo.Imagen )
                Utiles.Mensajes.Imagenes( this.Articulo.Id, [this.Articulo.Imagen] )
        }

        Cerrar()
        {
            this.Controlador.Vista.BarraDerecha.Modo = '';
        }
    }
